import { render, staticRenderFns } from "./modalFiltroUsuarios.vue?vue&type=template&id=2aa5f464&"
import script from "./modalFiltroUsuarios.vue?vue&type=script&lang=js&"
export * from "./modalFiltroUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports